import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VirkeskostnadBaseCommand } from "./VirkeskostnadBaseCommand";
export class CreateVirkeskostnaderCommand extends VirkeskostnadBaseCommand {
    mattslag: string;
    handelssortimentId?: number;
    handelssortimentsgruppId?: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateVirkeskostnaderCommand";

    constructor(
        guid: string,
        virkeskopskontraktGUID: string,
        virkeskopsatgardGUID: string,
        mattslag: string,
        handelssortimentId?: number,
        handelssortimentsgruppId?: number) {
        super(CreateVirkeskostnaderCommand.$type, CommandType.Insert);
        this.guid = guid;
        this.virkeskopskontraktGuid = virkeskopskontraktGUID;
        this.virkeskopsatgardGuid = virkeskopsatgardGUID;
        this.mattslag = mattslag;
        this.handelssortimentId = handelssortimentId;
        this.handelssortimentsgruppId = handelssortimentsgruppId;
    }
}
